export default "__VITE_ASSET__S42lK$dA__"